export default __webpack_public_path__ + "static/media/template.08e975c3.svg";